import { ComboBoxDoubleLineOption } from '../../cdl/ComboBox/ComboBox';
import type { ComboBoxOptionComponentProps } from '../../cdl/ComboBox/types/ComboBoxComponentProps';
import { formatCompanyName } from '../../common/helpers/formatCompanyName.helper';
import { formatPort } from '../../common/helpers/formatPort.helper';
import { formatVessel } from '../../common/helpers/formatVessel.helper';
import { translate } from '../../common/helpers/translate.helper';

import type { IntegrationOrderSelectOption } from './IntegrationOrderSelect';

export const IntegrationOrderDoubleLineOption = ({
    option,
}: ComboBoxOptionComponentProps<IntegrationOrderSelectOption>) => {
    const vesselName = formatVessel({ vessel: option.order.vessel });
    const companyName = formatCompanyName({ company: option.order.customer }) || '';

    const description = option.order.port
        ? translate('integrationsOverview.orderOption', {
              vesselName,
              portName: formatPort({ port: option.order.port }),
              companyName,
          })
        : translate('integrationsOverview.orderOptionWithoutPort', { vesselName, companyName });

    return <ComboBoxDoubleLineOption title={option.label} description={description} />;
};
